export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('bn-BD', {
    style: 'currency',
    currency: 'BDT',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const formatDate = (date) => {
  if (!date) return 'N/A';
  return new Date(date).toLocaleDateString('bn-BD', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

export const formatFileSize = (bytes) => {
  if (bytes === undefined || bytes === null) return 'N/A';
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const formatDateTime = (date) => {
  if (!date) return 'N/A';
  return new Date(date).toLocaleString('bn-BD');
};

export const formatPhoneNumber = (phone) => {
  if (!phone) return 'N/A';
  if (phone.length === 11) {
    return `${phone.slice(0, 5)}-${phone.slice(5)}`;
  }
  return phone;
};

export const getStatusColor = (status) => {
  const colors = {
    active: 'text-green-800 bg-green-100',
    inactive: 'text-gray-800 bg-gray-100',
    pending: 'text-yellow-800 bg-yellow-100',
    approved: 'text-blue-800 bg-blue-100',
    disbursed: 'text-purple-800 bg-purple-100',
    closed: 'text-gray-800 bg-gray-100',
    defaulted: 'text-red-800 bg-red-100',
    overdue: 'text-red-800 bg-red-100',
    paid: 'text-green-800 bg-green-100',
  };
  return colors[status] || 'text-gray-800 bg-gray-100';
};

export const getLoanTypeLabel = (type) => {
  const labels = {
    general: 'সাধারণ ঋণ',
    emergency: 'জরুরি ঋণ',
    agriculture: 'কৃষি ঋণ',
    business: 'ব্যবসায়িক ঋণ',
    education: 'শিক্ষা ঋণ',
  };
  return labels[type] || type;
};